import { Link } from "react-router-dom";
import { Home } from "lucide-react";

/**
 * BackToHome — reusable absolute-positioned chip that sends users back to "/".
 *
 * Drop this near the top of any standalone page (no global nav). Defaults to
 * top-6 left-6 with a glassy dark background that reads on photo or solid hero
 * backgrounds. Override `className` for placement, or set `inline` to render
 * without absolute positioning.
 */
export default function BackToHome({
  to = "/",
  label = "Back to Home",
  className = "",
  inline = false,
  testid = "back-to-home",
}) {
  const wrapperClass = inline
    ? `inline-block ${className}`
    : `absolute top-6 left-6 z-30 ${className}`;

  return (
    <div className={wrapperClass}>
      <Link
        to={to}
        className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-black/40 hover:bg-black/60 backdrop-blur-md text-white/90 hover:text-white border border-white/20 hover:border-white/40 transition-all text-sm font-medium shadow-lg"
        data-testid={testid}
      >
        <Home className="w-4 h-4" />
        {label}
      </Link>
    </div>
  );
}
